import type { Data } from '@/api/api.ts'
import type { Discount } from '@/types/types.ts'
import axios from 'axios'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}discount/`

export const getDiscount = async (): Promise<Data<Discount>> => axios.get(urlPrefix)
